import { useParams } from "react-router-dom";

export const useRoomDetail = () => {
  // Get chat room id from url params
  const { id } = useParams();

  // Placeholder for future logic related to room details
  return { roomId: Number(id) || null };
};
